import { forwardRef } from 'react';
import { cx } from './utils';

export const TextInput = forwardRef(function TextInput({ className, ...props }, ref) {
  return <input {...props} ref={ref} className={cx('ui-input', className)} />;
});

export const TextArea = forwardRef(function TextArea({ className, ...props }, ref) {
  return <textarea {...props} ref={ref} className={cx('ui-textarea', className)} />;
});
